import { makeStyles } from "@material-ui/core";
import { CloseIcon } from "../../../../icons";
import { GroupBase, MultiValueRemoveProps, components } from "react-select5";

export function MultiValueRemoveComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: MultiValueRemoveProps<Option, IsMulti, Group>) {
  const classes = useStyles();
  return (
    <components.MultiValueRemove {...props}>
      {props.selectProps.isDisabled ? (
        <div></div>
      ) : (
        <CloseIcon className={classes.icon} />
      )}
    </components.MultiValueRemove>
  );
}
const useStyles = makeStyles((theme) => ({
  icon: {
    width: "1rem",
    height: "1rem",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
